import { FunctionComponent } from 'react';
import InsightCardWrapper from './insightCard.style';
import InsightsType from '../../types/insights';

type InsightCardType = {
  insight: InsightsType;
};
const InsightCard: FunctionComponent<InsightCardType> = ({ insight }) => {
  return (
    <InsightCardWrapper image={insight.titleImageUrl}>
      <div>
        <div className="insightcard--image" />
      </div>
      <div className="insightcard-desc-wrap">
        <p className="insightcard--title">{insight.title}</p>
        <div className="insightcard--tags">
          {insight.tags &&
            insight.tags.map((tag: string, index: number) => (
              <p className="insightcard--tag" key={index}>
                #{tag}
              </p>
            ))}
        </div>
      </div>
    </InsightCardWrapper>
  );
};

export default InsightCard;
